import React from 'react';
import { INPUT_MAP } from './form.config';

import { FORM_KEYS } from './form.keys';

const flexStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '6rem',
};

export const columns = [
  {
    title: (
      <div className="col-title">
        <span />
      </div>
    ),
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },

  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.TITLE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.TITLE.key,
    key: FORM_KEYS.TITLE.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.TITLE.key] },
    style: { width: '25%', 'border-right': '1px solid gray' },
  },

  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.DES.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.DES.key,
    key: FORM_KEYS.DES.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.DES.key] },
    style: { flexShrink: 1 },
  },
];
